export default {
  displayName: 'Roofing Warranty Table',
  allowableParents: ['Section'],
};
